import { useSelector } from 'react-redux';
import './alert-window.scss';

import { useAppDispatch } from '../../hooks';
import { closeAlert, selectIsAlertOpen, selectAlertData } from './alertWindowSlice';
import { useEffect } from 'react';

export interface AlertWindowProps {
    children: React.ReactNode
}

export function AlertWindow(props: AlertWindowProps) {
    const isOpen = useSelector(selectIsAlertOpen);
    const alertData = useSelector(selectAlertData);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (isOpen && alertData) {
            // Используем duration если указан, иначе autoCloseDelay, иначе 5000ms по умолчанию
            const delay = alertData.duration || alertData.autoCloseDelay || 5000;
            
            if (alertData.autoClose !== false) {
                const timer = setTimeout(() => {
                    dispatch(closeAlert());
                }, delay);

                return () => clearTimeout(timer);
            }
        }
    }, [isOpen, alertData, dispatch]);

    const handleClose = () => {
        dispatch(closeAlert());
    };

    const getAlertTypeClass = () => {
        if (!alertData) return '';
        switch (alertData.type) {
            case 'error':
                return 'alert-error';
            case 'warning':
                return 'alert-warning';
            case 'success':
                return 'alert-success';
            case 'info':
            default:
                return 'alert-info';
        }
    };

    return (
        <>
            <div>
                {props.children}
            </div>
            {isOpen && alertData && (
                <section className="alert-window_wrapper">
                    <div className="darked-background" onClick={handleClose}></div>
                    <div className={`alert-window ${getAlertTypeClass()}`}>
                        {alertData.title && (
                            <div className="alert-title">
                                {alertData.title}
                            </div>
                        )}
                        <div className="alert-message">
                            {alertData.message}
                        </div>
                        <div className="alert-buttons">
                            {alertData.showCloseButton !== false && (
                                <div 
                                    className="main-button black close"
                                    onClick={handleClose}
                                >
                                    ОК
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            )}
        </>
    );
}
